import React from 'react';
import { Icon } from '@material-ui/core';
import Card from '../../atoms/Card';

export interface SummaryItem {
  icon: string;
  header: string;
  data: number;
}

export interface SummaryListProps {
  items: SummaryItem[];
}

const SummaryList: React.FC<SummaryListProps> = ({ items }) => {
  return (
    <div className='summary-cards'>
      {items.map(({ icon, header, data }: SummaryItem, idx: number) => {
        return (
          <Card className='summary-cards__item-card' key={`${icon}-${idx}`}>
            <Card.Content className='summary-cards__item-card-content'>
              <div className='summary-cards__item-title'>
                <Icon className='u-icon-s u-mr4'>{icon}</Icon>
                <p
                  className='summary-cards__item-title-content'
                  data-testid='summary-cards-item-title'
                  data-testid-e2e='summary-cards-item-title'>
                  {header}
                </p>
              </div>
              <p className='summary-cards__item-value' data-testid='summary-cards-item-value' data-testid-e2e='summary-cards-item-value'>
                {data}
              </p>
            </Card.Content>
          </Card>
        );
      })}
    </div>
  );
};

export default SummaryList;
